<template>
  <TheModal title="Прикачени файлове" @close="close(false)" :onlyCancel="true">
    <main class="files-content">
      <section
        class="files-wrapper"
        v-if="document.files && document.files.length"
      >
        <main
          class="file"
          v-for="(file, index) of document.files"
          :key="`${file.nmae}-${index}`"
        >
          <div class="name">
            <span class="mck3">Q</span>
            <p>{{ file.name }}</p>
          </div>

          <div class="actions">
            <span @click="downloadFile(file.path)" class="mck3">Q</span>
            <span @click="removeFile(index)" class="mck mck--delete">b</span>
          </div>
        </main>
      </section>
      <p v-else>Няма прикачени файлове</p>
    </main>
  </TheModal>
</template>

<script>
import TheModal from "./TheModal.vue";
export default {
  props: ["id", "type"],
  components: { TheModal },
  data() {
    return {
      document: {},
      isUpdated: false,
    };
  },
  methods: {
    close() {
      this.$emit("close", this.isUpdated);
    },
    async downloadFile(filename) {
      try {
        // the route handler is in the inventory route since it's pretty much the same functionality
        const response = await this.$http.get(
          `${process.env.VUE_APP_BASE_URI}/inventory/download/${this.id}/${filename}`,
          {
            responseType: "blob",
          }
        );

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();

        // Cleanup
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (err) {
        console.error(err);
      }
    },
    removeFile(index) {
      if (this.type === "deliveries") {
        if (
          this.document.files.length === 1 &&
          (this.document.requests ? !this.document.requests.length : true)
        ) {
          return this.$snotify.error("Не може да изтриете последния файл");
        }
      }

      this.document.files.splice(index, 1);
      this.isUpdated = true;
      this.updateDocument();
    },
    async updateDocument() {
      try {
        const fd = new FormData();
        fd.append("data", JSON.stringify(this.document));

        if (this.document.files && this.document.files.length) {
          for (let f of this.document.files) {
            fd.append("files", f);
          }
        }
        let url = `${process.env.VUE_APP_BASE_URI}/${this.type}`;
        if (this.type === "deliveries") url += `/${this.document._id}`;
        await this.$http.put(url, fd);
      } catch (err) {
        console.log(err);
      }
    },
    async getDocument() {
      try {
        const res = await this.$http.get(
          `${process.env.VUE_APP_BASE_URI}/${this.type}/${this.id}`
        );
        this.document = res.data;
      } catch (err) {
        console.log(err);
      }
    },
  },
  mounted() {
    this.getDocument();
  },
};
</script>

<style scoped lang="scss">
.files-content {
  text-align: center;

  .files-wrapper {
    display: flex;
    flex-direction: column;
    gap: 5px;

    .file {
      background: #e9e9e9;
      border-radius: 4px;
      display: flex;
      justify-content: space-between;
      padding: 5px;

      > div {
        align-items: center;
        display: flex;
        gap: 10px;

        &.name {
          span {
            font-size: 26px;
          }
        }

        &.actions {
          span {
            cursor: pointer;
            font-size: 20px;

            &:first-of-type {
              color: #cb6d28;
            }
          }
        }
      }
    }
  }
}
</style>
